module.exports = "<div class=\"container\">\n  <h3>导入</h3>\n  <form>\n    <div class=\"form-group\">\n      <label for=\"file\" class=\"text-danger\">文件 <span>(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"DImportCtrl.file\" name=\"file\" required ngf-model-invalid=\"errorFile\" class=\"form-control\">\n    </div>\n    \n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"DImportCtrl.upload(DImportCtrl.file)\">导入</button>\n  </form>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/devices/import/import.html
// module id = 344
// module chunks = 0